// Remembers keywords the user has typed or loaded, so keyword editors can suggest
// them. Keywords are split into separate pools by scope so distinct vocabularies
// don't cross-contaminate (unit keywords vs. ability keywords vs. weapon abilities
// vs. army names). Each scope is a shared module-level singleton, persisted to its
// own localStorage key. Suggestions are stored in their plain display form (without
// the app's `**^^…^^**` formatting).
import { createSuggestionStore, type SuggestionStore } from './useSuggestionStore.js';

export type KeywordScope = 'ability' | 'unit' | 'weapon' | 'army' | 'enhancement';

const STORAGE_KEYS: Record<KeywordScope, string> = {
  ability: 'studio:abilityKeywords',
  unit: 'studio:unitKeywords',
  weapon: 'studio:weaponAbilities',
  army: 'studio:armyNames',
  enhancement: 'studio:enhancementTables',
};

// One memoized store per scope so every editor with the same scope shares state.
const stores = new Map<KeywordScope, () => SuggestionStore>();

export function useKeywordSuggestions(scope: KeywordScope = 'ability'): SuggestionStore {
  let store = stores.get(scope);
  if (!store) {
    store = createSuggestionStore(STORAGE_KEYS[scope]);
    stores.set(scope, store);
  }
  return store();
}
